import type { NautilusDesignerPermissions } from "../../state/appConfig/shared.ts";
import { useNautilusSelector } from "../../state/shared.ts";

/**
 * Returns `true` if the user has permission to make their own templates, i.e.
 * save, edit, or delete.
 * Returns `false` if the user needs a paid plan, and should see a prompt to
 * upgrade.
 * Returns `null` if the permissions have not been loaded yet and the UX should
 * show some pending state until this value is resolved.
 */
export const useDesignerPermission = (name: keyof NautilusDesignerPermissions): boolean | null =>
  useNautilusSelector((state) => {
    const { permissions } = state.appConfig;
    return permissions ? permissions[name] : null;
  });
